import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {stepperData} from '../../contants';
import {RootState} from '../../../../../store/redux';
import SelectStep from '../../elements/selectedStep';
import DotsLoading from '../../../../../components/dotsLoading';
import Stepper from '../../../../../components/mazraeKit/stepper';
import SuccessRegisterStoreModal from '../../modal/successRegisterStoreModal';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import usePostLabRedesign from '../../../../../services/hookService/postLabRedesignView/usePostLabRedesign';
import {addRegisterStoreFormData} from '../../../../../store/redux/registerStore';
import useGetStoreSupplierProfile from '../../../../../services/hookService/getStoreSupplierProfile/useGetStoreSupplierProfile';

const RegisterLab = () => {
  const dispatch = useDispatch();

  const {state: stateParams} = useLocation();

  const state = useSelector((state: RootState) => state.registerStore);
  const navigate = useNavigate();
  const [touched, setTouched] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<number>(stateParams?.tab || 2);

  const handleAfterSuccessSupplierProfile = (data: IStoreSupplierProfile) => {
    if (!state?.national_card?.file && !state?.national_card?.national_card) {
      dispatch(
        addRegisterStoreFormData({
          ...state,
          name: '',
          supplier_profile_guid: data?.profile_guid,
          national_card: {file: null, national_card: ''},
          phone_number: data.phone,
        }),
      );
    }
  };
  const {data, isLoading} = useGetStoreSupplierProfile({
    handleAfterSuccessSupplierProfile,
  });

  const onSuccess = () => {
    setIsSuccessModal(true);
  };

  const {mutate, isLoadingPostLab} = usePostLabRedesign({
    onSuccess,
  });

  useEffect(() => {
    setCurrentStep(stateParams?.tab || 2);
  }, [stateParams?.tab]);

  return (
    <div className="flex h-full flex-col">
      <CustomHeader
        title="ثبت آزمایشگاه"
        preIcon="icon-nameArrow---Right"
        postComponent={() => (
          <i
            className={`icon-namechat text-[25px] text-gray-700`}
            onClick={() => {
              navigate('/my-chats');
            }}
          />
        )}
        isActiveRightIcon={true}
      />
      {isLoading ? (
        <div className="flex h-full justify-center items-center">
          <DotsLoading />
        </div>
      ) : (
        <div className="flex flex-col h-full overflow-y-auto">
          <div className="w-full h-full flex flex-col overflow-y-auto py-3 px-3">
            <Stepper currentStep={currentStep} steps={stepperData} />
            <SelectStep
              mutateFn={mutate}
              touched={touched}
              setTouched={setTouched}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              profileData={data}
              setIsSuccessModal={setIsSuccessModal}
              isLoadingMutattion={isLoadingPostLab}
            />
          </div>
        </div>
      )}
      <SuccessRegisterStoreModal
        {...{isSuccessModal, setIsSuccessModal}}
        type="lab"
        // data={data}
      />
      <MainFooter />
    </div>
  );
};

export default RegisterLab;
